// export const HOST_URL = 'https://api.airtouch.solar';
// export const TEST_HOST_URL = 'https://test-api.airtouch.solar';

import { getDateStr } from "./components/utils";

let url = window.location.href.includes("airtouch.solar")
  ? "https://api-prod.airtouch.solar:8443"
  : "https://vehicle-api.airtouch.solar";
let socketUrl = window.location.href.includes("airtouch.solar")
  ? "https://api-prod.airtouch.solar:7443"
  : "https://vehicle-api.airtouch.solar";

if (window.location.href.includes("localhost")) {
  // url = "http://localhost:8443";
  // socketUrl = "http://localhost:4003";
  // url = "https://api-staging.airtouch.solar:4000";
  // socketUrl = "https://api-staging.airtouch.solar:4003";
  url = "http://localhost:4000";
  socketUrl = "http://localhost:4003";
} else if (window.location.href.includes("staging")) {
  url = "https://api-staging.airtouch.solar:4000";
  socketUrl = "https://api-staging.airtouch.solar:4003";
} else if (window.location.href.includes("airtouch-tmp")) {
  url = "https://api-prod.airtouch.solar:8443";
  socketUrl = "https://api-prod.airtouch.solar:7443";
}

export const HOST_URL = url;
export const SOCKET_URL = socketUrl;
export const LOCAL_STORAGE_TOKEN_KEY = "authToken";
export const LOCAL_STORAGE_USER_KEY = "user";
export const LOCAL_STORAGE_PROJECT = "project";
export const LOCAL_STORAGE_ROBOT = "robot";
export const LOCAL_STORAGE_ERROR = "error";
export const LOCAL_STORAGE_VEHICLE = "vehicle";
export const LOCAL_STORAGE_LIVE_REPORT = "live-report";

export const MENU_URLS = [
  "/dashboard",
  ["/robots", "/robot", "/vehicle"],
  "/robotSettings",
  "/tasks",
  "/messages",
  "/errors",
  "/daily-activity",
  "/availability",
  "/reports",
  "/weather",
  "/settings",
];

export const COUNTRIES = [
  "Afghanistan",
  "Albania",
  "Algeria",
  "Andorra",
  "Angola",
  "Antigua and Barbuda",
  "Argentina",
  "Armenia",
  "Australia",
  "Austria",
  "Azerbaijan",
  "Bahamas",
  "Bahrain",
  "Bangladesh",
  "Barbados",
  "Belarus",
  "Belgium",
  "Belize",
  "Benin",
  "Bhutan",
  "Bolivia",
  "Bosnia and Herzegovina",
  "Botswana",
  "Brazil",
  "Brunei ",
  "Bulgaria",
  "Burkina Faso",
  "Burundi",
  "Côte d'Ivoire",
  "Cabo Verde",
  "Cambodia",
  "Cameroon",
  "Canada",
  "Central African Republic",
  "Chad",
  "Chile",
  "China",
  "Colombia",
  "Comoros",
  "Congo (Congo-Brazzaville)",
  "Costa Rica",
  "Croatia",
  "Cuba",
  "Cyprus",
  "Czechia (Czech Republic)",
  "Democratic Republic of the Congo",
  "Denmark",
  "Djibouti",
  "Dominica",
  "Dominican Republic",
  "Ecuador",
  "Egypt",
  "El Salvador",
  "Equatorial Guinea",
  "Eritrea",
  "Estonia",
  'Eswatini (fmr. "Swaziland")',
  "Ethiopia",
  "Fiji",
  "Finland",
  "France",
  "Gabon",
  "Gambia",
  "Georgia",
  "Germany",
  "Ghana",
  "Greece",
  "Grenada",
  "Guatemala",
  "Guinea",
  "Guinea-Bissau",
  "Guyana",
  "Haiti",
  "Holy See",
  "Honduras",
  "Hungary",
  "Iceland",
  "India",
  "Indonesia",
  "Iran",
  "Iraq",
  "Ireland",
  "Israel",
  "Italy",
  "Jamaica",
  "Japan",
  "Jordan",
  "Kazakhstan",
  "Kenya",
  "Kiribati",
  "Kuwait",
  "Kyrgyzstan",
  "Laos",
  "Latvia",
  "Lebanon",
  "Lesotho",
  "Liberia",
  "Libya",
  "Liechtenstein",
  "Lithuania",
  "Luxembourg",
  "Madagascar",
  "Malawi",
  "Malaysia",
  "Maldives",
  "Mali",
  "Malta",
  "Marshall Islands",
  "Mauritania",
  "Mauritius",
  "Mexico",
  "Micronesia",
  "Moldova",
  "Monaco",
  "Mongolia",
  "Montenegro",
  "Morocco",
  "Mozambique",
  "Myanmar (formerly Burma)",
  "Namibia",
  "Nauru",
  "Nepal",
  "Netherlands",
  "New Zealand",
  "Nicaragua",
  "Niger",
  "Nigeria",
  "North Korea",
  "North Macedonia",
  "Norway",
  "Oman",
  "Pakistan",
  "Palau",
  "Palestine State",
  "Panama",
  "Papua New Guinea",
  "Paraguay",
  "Peru",
  "Philippines",
  "Poland",
  "Portugal",
  "Qatar",
  "Romania",
  "Russia",
  "Rwanda",
  "Saint Kitts and Nevis",
  "Saint Lucia",
  "Saint Vincent and the Grenadines",
  "Samoa",
  "San Marino",
  "Sao Tome and Principe",
  "Saudi Arabia",
  "Senegal",
  "Serbia",
  "Seychelles",
  "Sierra Leone",
  "Singapore",
  "Slovakia",
  "Slovenia",
  "Solomon Islands",
  "Somalia",
  "South Africa",
  "South Korea",
  "South Sudan",
  "Spain",
  "Sri Lanka",
  "Sudan",
  "Suriname",
  "Sweden",
  "Switzerland",
  "Syria",
  "Tajikistan",
  "Tanzania",
  "Thailand",
  "Timor-Leste",
  "Togo",
  "Tonga",
  "Trinidad and Tobago",
  "Tunisia",
  "Turkey",
  "Turkmenistan",
  "Tuvalu",
  "Uganda",
  "Ukraine",
  "United Arab Emirates",
  "United Kingdom",
  "United States of America",
  "Uruguay",
  "Uzbekistan",
  "Vanuatu",
  "Venezuela",
  "Vietnam",
  "Yemen",
  "Zambia",
  "Zimbabwe",
];

export const getFormattedDate = ({
  date,
  dateOnly,
  dateWithYear,
  hourOnly,
  includeSeconds,
  dateWithYearDashes,
}) => {
  if (!date) return;

  date = new Date(date);

  const isToday = getDateStr(date) === getDateStr(new Date());
  let options;
  if (dateOnly) options = { month: "numeric", day: "numeric" };
  else if (dateWithYear)
    options = { month: "numeric", day: "numeric", year: "numeric" };
  else if (hourOnly) options = { hour: "numeric", minute: "numeric" };
  else if (includeSeconds) {
    options = {
      hour: "numeric",
      minute: "numeric",
      second: "numeric",
    };

    if (!isToday) {
      options.day = "numeric";
      options.month = "numeric";
      options.year = "numeric";
    }
  } else
    options = {
      month: "numeric",
      day: "numeric",
      hour: "numeric",
      minute: "numeric",
    };

  if (dateWithYearDashes) {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are 0-based
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  }

  let str = date.toLocaleDateString("en-GB", options);
  if (hourOnly || (includeSeconds && isToday)) return str.split(",")[1];
  else return str;
};

export const camelCaseToText = (text) => {
  if (!text) return "";

  const result = text.replace(/([A-Z])/g, " $1");
  return result.charAt(0).toUpperCase() + result.slice(1);
};

export const dashedToTitle = (str) =>
  !str
    ? ""
    : str
        .split("-")
        .map(
          (word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase(),
        )
        .join(" ");

export const getFormattedDateToday = (d) => {
  d = new Date(d);
  return d.toTimeString().split(" ")[0];
};
